import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLlmArrowUp = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" className="icon-llm-arrow-up" data-icon="icon-llm-arrow-up" aria-hidden="true" {...props} ref={ref}><path d="M12 20.25V3.75" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/><path d="M5.25 10.5L12 3.75L18.75 10.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/></svg>);
});

IconLlmArrowUp.displayName = 'IconLlmArrowUp';
